<script>
export default {
    name: 'MenuCadastro',
    props: {
        me: null
    }
};
</script>

<template>
    <li class="dropdown nav-item">
        <a href="#" class="nav-link dropdown-toggle " data-toggle="dropdown"
           role="button" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-plus-circle"></i> CADASTROS <span class="caret"></span>
        </a>
        <ul class="dropdown-menu cadastro-dropdown">
            <!--
            <li><a href="#/acessorios"><i class="fa fa-cog"></i> Acessórios</a></li>
            <li><a href="#/cercas-eletronicas"><i class="fa fa-shield"></i> Cerca eletronica</a></li>
            -->
            <li><a href="#/chips" class="menu-item">
                <i class="fa fa-microchip text-primary"></i> 
                <span>Chips</span>
                <small class="text-muted">Gerenciar chips SIM</small>
            </a></li>
            
            
            <li><a href="#/clientes" class="menu-item">
                <i class="fa fa-users text-success"></i> 
                <span>Clientes</span>
                <small class="text-muted">Cadastro de clientes</small>
            </a></li>
            
            
            <li><a href="#/ordens-servicos" class="menu-item">
                <i class="fa fa-wrench text-warning"></i> 
                <span>Ordem de Serviço</span>
                <small class="text-muted">Ordens de serviço</small>
            </a></li>
            
            
            <!--<li><a href="#/ibuttons"><i class="fa fa-dot-circle-o"></i> IButtons</a></li>-->
            
            <li><a href="#/parceiros" class="menu-item">
                <i class="fa fa-handshake-o text-info"></i> 
                <span>Parceiros</span>
                <small class="text-muted">Rede de parceiros</small>
            </a></li>
            
            
            <li><a href="#/rastreadores" class="menu-item">
                <i class="fa fa-map-marker text-danger"></i> 
                <span>Rastreadores</span>
                <small class="text-muted">Dispositivos de rastreamento</small>
            </a></li>

            <li><a href="#/revendas" class="menu-item">
                <i class="fa fa-handshake-o text-info"></i> 
                <span>Revendas</span>
                <small class="text-muted">Rede de revendas</small>
            </a></li>
            
            <!-- <li role="separator" class="divider" ></li>
            <li><a href="#/sensores-temperatura"><i class="fa fa-thermometer-half"></i> Sensor de temperatura</a></li>-->
            
            
            <li><a href="#/usuarios" class="menu-item">
                <i class="fa fa-user-circle text-purple"></i> 
                <span>Usuários Administrativos</span>
                <small class="text-muted">Gestão de usuários</small>
            </a></li>
            
            
            <li><a href="#/veiculos" class="menu-item">
                <i class="fa fa-car text-primary"></i> 
                <span>Veículos</span>
                <small class="text-muted">Frota de veículos</small>
            </a></li>
        </ul>
    </li>
</template>

<style scoped>
.cadastro-menu-toggle {
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50 !important;
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 15px 20px;
}

.cadastro-menu-toggle:hover {
    color: #3498db !important;
    background-color: rgba(52, 152, 219, 0.1);
}

.cadastro-menu-toggle i {
    margin-right: 8px;
    font-size: 14px;
}

.cadastro-dropdown {
    min-width: 280px;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border: none;
    padding: 10px 0;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.menu-item {
    padding: 12px 20px !important;
    color: #2c3e50 !important;
    text-decoration: none !important;
    display: flex !important;
    align-items: center;
    transition: all 0.3s ease;
    border-left: 3px solid transparent;
}

.menu-item:hover,
.menu-item:focus {
    background: linear-gradient(90deg, rgba(52, 152, 219, 0.1) 0%, rgba(52, 152, 219, 0.05) 100%);
    color: #2c3e50 !important;
    text-decoration: none !important;
    border-left: 3px solid #3498db;
    transform: translateX(2px);
}

.menu-item i {
    font-size: 16px;
    width: 20px;
    margin-right: 12px;
    text-align: center;
}

.menu-item span {
    font-weight: 600;
    flex: 1;
}

.menu-item small {
    display: block;
    font-size: 11px;
    margin-top: 2px;
    margin-left: 32px;
    font-weight: normal;
}

.menu-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #e9ecef 50%, transparent 100%);
    margin: 8px 20px;
}

.text-purple {
    color: #9b59b6 !important;
}

/* Animação para o dropdown */
.cadastro-dropdown {
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
}

.dropdown.open .cadastro-dropdown {
    opacity: 1;
    transform: translateY(0);
}

/* Responsividade */
@media (max-width: 767px) {
    .cadastro-dropdown {
        min-width: 250px;
        margin-top: 5px;
    }
    
    .menu-item {
        padding: 10px 15px !important;
    }
    
    .menu-item small {
        margin-left: 27px;
    }
}

/* Efeito hover adicional para ícones */
.menu-item:hover i {
    transform: scale(1.1);
    transition: transform 0.2s ease;
}
</style>
